import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TGetFinixInfoRequestSchema } from "./getFinixInfo.schema";

export const getFinixInfo =
  (axios: IAxiosInstance) => async (params: TGetFinixInfoRequestSchema) => {
    const response = await axios.noRetry.get("/api/business-cards/finix-info", {
      params,
    });
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Error getting Finix info");
  };
